"use client";

import { styled } from "@mui/material/styles";

export const StyledRoot = styled("div")(({ theme }) => ({
  width: "100%",
  "& strong": {
    fontWeight: 600,
  },
  "& .price": {
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  "& .variant-group": {
    gap: "0.5rem",
    display: "flex",
    alignItems: "center",
    "& .MuiChip-root": {
      height: 28,
      cursor: "pointer",
      borderRadius: "6px",
    },
  },
}));

export const ProductImageWrapper = styled("div")(({ theme }) => ({
  height: 460,
  display: "flex",
  overflow: "hidden",
  position: "relative",
  justifyContent: "center",
  borderRadius: theme.spacing(3),
  backgroundColor: theme.palette.grey[50],
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.grey[200]}`,
  [theme.breakpoints.down("sm")]: {
    height: 300,
  },
  "& .image-box": {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  "& .chip-container": {
    position: "absolute",
    top: 12,
    left: 12,
    zIndex: 1,
  },
}));

export const PreviewImage = styled("div", {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ theme, selected }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "10px",
  overflow: "hidden",
  width: 64,
  height: 64,
  cursor: "pointer",
  position: "relative",
  backgroundColor: theme.palette.grey[50],
  opacity: selected ? 1 : 0.6,
  transition: "all 0.2s ease-in-out",
  border: `2px solid ${selected ? theme.palette.primary.main : theme.palette.grey[300]}`,
  "&:hover": {
    opacity: 1,
    borderColor: theme.palette.primary.light,
  },
}));

export const ImageContainer = styled("div")(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
}));
